/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CertificateItem,
  ErrorResponse,
} from '../models/index';
import {
    CertificateItemFromJSON,
    CertificateItemToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class CertificateControllerApi extends runtime.BaseAPI {

    /**
     */
    async getAllCertificatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CertificateItem>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/certificates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CertificateItemFromJSON));
    }

    /**
     */
    async getAllCertificates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CertificateItem>> {
        const response = await this.getAllCertificatesRaw(initOverrides);
        return await response.value();
    }

}
